import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    alias: "/home/:id?",
  },
  {
    path: "/past-events",
    name: "Events",
    component: () => import("../views/PastEvents.vue"),
  },
  {
    path: "/past-event",
    name: "Event",
    component: () => import("../views/PastEvent.vue"),
  },
  {
    path: "/register",
    name: "Registration",
    component: () => import("../views/Auth/Registration.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Auth/Login.vue"),
  },
  {
    path: "/super-admin",
    name: "SuperAdmin",
    component: () => import("../views/Auth/SuperAdminLogin.vue"),
  },
  {
    path: "/admin",
    name: "Admin",
    component: () => import("../views/Admin/Admin.vue"),
  },
  {
    path: "/profile",
    name: "Profile",
    component: () => import("../views/Profile.vue"),
  },
  {
    path: "/recovery",
    name: "Recovery",
    component: () => import("../views/Auth/Recovery.vue"),
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () => import("../views/Auth/ResetPassword.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

/*router.beforeEach((to, from, next) => {
  if (to.name != "Conference" && localStorage.getItem("conference") == null)
    next({ name: "Conference" });
  else next();
});
*/

export default router;
